import { InteractiveBannersData03 } from '../../../Components/InteractiveBanners/InteractiveBannersData'
import { Col, Container } from 'react-bootstrap'
import { m } from 'framer-motion'
// import ProgressBar from '../../../Components/ProgressBar'
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from 'swiper/react'

const UnknownSection = (props) => {
    const style = { "--overlay-color": typeof (["#0000004a", "#0000004a"]) === "object" ? `linear-gradient(to right top, ${["#0000004a", "#0000004a"].map((item, i) => item)})` : ["#0000004a", "#0000004a"] }
    return (
        <>

            <section>
                <Container className='mt-[50px]'>
                    <Col xl={8} lg={10} className="text-center w-fit mb-[50px]">
                        <h3 className="font-serif text-[30px] mb-[2px]  font-medium text-[#146084] -tracking-[1px]">Project Components</h3>
                    </Col>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        modules={[Pagination, Autoplay]}
                        loop={true}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        breakpoints={{
                            1200: { slidesPerView: 1 },
                            992: { slidesPerView: 1 },
                            768: { slidesPerView: 1 },
                        }}
                    >
                        {
                            InteractiveBannersData03?.map((item, i) => {
                                return (
                                    <SwiperSlide>
                                        <m.div key={i} className="col " {...{ ...props.fadeIn, transition: { delay: i * 0.2 } }}>
                                            <div className="interactivebanners-style-03 flex g-0 md:flex-col relative overflow-hidden rounder-[6px]" style={style}>
                                                <div className="interactivebanners-box-image w-[40%] items-center md:w-[100%] relative flex justify-center overflow-hidden">
                                                    {item?.img && <img height={202} className="interactivebanners-img bg-cover h-[300px] w-auto relative overflow-hidden" src={item?.img} alt="interactivebanners" />}
                                                </div>
                                                <div className="interactivebanners-box-content w-[60%]  md:w-[100%] bg-white p-[20px] relative lg:p-[10px] xs:p-[10px]">
                                                    {item?.title && <p className="interactivebanners-title text-center font-bold text-darkgray font-serif text-[20px] uppercase no-underline">{item.title}</p>}
                                                    <br />
                                                    {item?.subtitle && <p className='text-start mt-[10px]'><span className="left-0 text-start text-[17px] text-black right-0 h-full w-full">{item.subtitle}</span></p>}

                                                    <ul className="mt-[10px] space-y-2 text-black text-justify text-[14px] pl-5">
                                                        {item?.list?.map((ele, idx) => (
                                                            <li key={idx} className="relative pl-2 before:absolute before:left-[-1rem] before:content-['•'] before:text-black">
                                                                {ele}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </m.div>
                                    </SwiperSlide>
                                )
                            })
                        }
                    </Swiper>

                </Container>
            </section >




        </>
    )
}

export default UnknownSection